let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5Hj8w")).then(() => parcelRequire('fbdwm'));